module.exports = __webpack_public_path__ + "img/52002743_L.934ec8c2.png";